import styled from 'styled-components';

const Triangle = styled.div`
    width: 0; 
    height: 0; 
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-top: 40px solid rgb(239,239,239);
`;

export default Triangle;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/triangle.js